var _excluded = ["as", "grow", "shrink", "align", "verticalFill", "padding", "basis", "height", "skipIf"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { media } from '@domain-group/fe-brary';
import { shallowToBreakpointed, reduceStyles, arrayify, resolveSpacingUnit } from './utilities';
import { ALIGN, SIZE_CLASSES } from './types';
import { jsx as ___EmotionJSX } from "@emotion/core";
var defaultStyleProps = {
  grow: undefined,
  shrink: undefined,
  align: undefined,
  verticalFill: undefined,
  padding: undefined,
  basis: undefined
};
export var stackItemStyles = props => {
  var _shallowToBreakpointe = shallowToBreakpointed(_objectSpread(_objectSpread({}, defaultStyleProps), props)),
    grow = _shallowToBreakpointe.grow,
    shrink = _shallowToBreakpointe.shrink,
    align = _shallowToBreakpointe.align,
    padding = _shallowToBreakpointe.padding,
    verticalFill = _shallowToBreakpointe.verticalFill,
    height = _shallowToBreakpointe.height,
    basis = _shallowToBreakpointe.basis;
  var breakpointedStyles = SIZE_CLASSES.map(breakpoint => {
    var _ref;
    return {
      flexGrow: typeof (grow === null || grow === void 0 ? void 0 : grow[breakpoint]) === 'undefined' ? undefined : +grow[breakpoint],
      flexShrink: typeof (shrink === null || shrink === void 0 ? void 0 : shrink[breakpoint]) === 'undefined' ? undefined : +shrink[breakpoint],
      alignSelf: align !== null && align !== void 0 && align[breakpoint] ? ALIGN[align[breakpoint]] : null,
      padding: padding !== null && padding !== void 0 && padding[breakpoint] ? arrayify(padding[breakpoint]).map(amount => resolveSpacingUnit(amount)).join(' ') : undefined,
      height: (_ref = height ? height[breakpoint] : undefined) !== null && _ref !== void 0 ? _ref : verticalFill !== null && verticalFill !== void 0 && verticalFill[breakpoint] ? '100%' : 'auto',
      flexBasis: basis === null || basis === void 0 ? void 0 : basis[breakpoint]
    };
  });
  var _reduceStyles = reduceStyles(breakpointedStyles),
    _reduceStyles2 = _slicedToArray(_reduceStyles, 3),
    mobileStyles = _reduceStyles2[0],
    tabletStyles = _reduceStyles2[1],
    desktopStyles = _reduceStyles2[2];
  return _objectSpread(_objectSpread({}, mobileStyles), {}, {
    [media('>=tablet')]: tabletStyles,
    [media('>=desktop')]: desktopStyles
  });
};
function StackItem(_ref2) {
  var as = _ref2.as,
    grow = _ref2.grow,
    shrink = _ref2.shrink,
    align = _ref2.align,
    verticalFill = _ref2.verticalFill,
    padding = _ref2.padding,
    basis = _ref2.basis,
    height = _ref2.height,
    skipIf = _ref2.skipIf,
    props = _objectWithoutProperties(_ref2, _excluded);
  var Component = as || 'div';
  return skipIf ? null : ___EmotionJSX(Component, _extends({
    css: stackItemStyles({
      grow,
      shrink,
      align,
      verticalFill,
      padding,
      basis,
      height
    })
  }, props));
}
export default StackItem;